export const openAuthDialog = ({
  authType,
  trk,
  regTrackingAttributes,
  onSuccessActions = () => {},
  onCleanUp = () => {},
  variantName = '',
}) => {
  window?.nwapi?.ui?.showAuthDialog({
    authType,
    version: 2,
    abTest: {
      variantName,
    },
    trk,
    regTrackingAttributes,
    flowConfig: {
      errorToastPositionMobile: 'bottom-center',
    },
    onSuccess: onSuccessActions,
    onCleanUp,
  });
};
